import { motion } from "framer-motion";
import { fmtAxv } from "../lib/tokens";

/** Honest, itemized fee lines. Integers only. Always visible before a spend. */
export const FeeLines = ({ principalLabel, principalSub, feeLines = [], totalSub, testid = "fee-lines" }) => (
  <div className="mono text-[11px] leading-relaxed" data-testid={testid}>
    <div className="flex justify-between text-white/70">
      <span>{principalLabel}</span>
      <span data-testid="fee-principal">{fmtAxv(principalSub)}</span>
    </div>
    {feeLines.map((f) => (
      <div
        key={f.label}
        className="flex justify-between text-white/40"
        data-testid={`fee-line-${f.label.toLowerCase().includes("network") ? "network" : "endeavorum"}`}
      >
        <span>{f.label}</span>
        <span>{fmtAxv(f.amount_sub)}</span>
      </div>
    ))}
    <div className="mt-2 flex justify-between border-t border-white/12 pt-2 text-[var(--stage-gold)]">
      <span className="tracked text-[9px]">Total debited</span>
      <span data-testid="fee-total">{fmtAxv(totalSub)}</span>
    </div>
  </div>
);

export const Receipt = ({ tx }) => {
  if (!tx) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="glass-warm rounded-xl p-5"
      data-testid="ledger-receipt"
    >
      <div className="tracked mb-3 text-[9px] text-white/40">Ledger receipt · immutable</div>
      <div className="mono mb-3 break-all text-[10px] text-white/35" data-testid="receipt-txid">
        {tx.tx_id}
      </div>
      <div className="mono space-y-1 text-[11px]">
        {tx.entries.map((e, i) => {
          const memo = (e.memo || e.account).toLowerCase();
          const testid = memo.includes("network")
            ? "fee-line-network"
            : memo.includes("endeavorum flat")
              ? "fee-line-endeavorum"
              : undefined;
          return (
            <div
              key={`${e.direction}-${e.account}-${i}`}
              className="flex justify-between gap-4"
              data-testid={testid}
            >
              <span className={e.direction === "debit" ? "text-[var(--stage-ember)]" : "text-emerald-400/80"}>
                {e.direction === "debit" ? "DR" : "CR"} {e.memo || e.account}
              </span>
              <span className="text-white/60">{fmtAxv(e.amount_sub)}</span>
            </div>
          );
        })}
      </div>
      <div className="mono mt-3 border-t border-white/10 pt-2 text-[10px] text-white/35">
        debits = credits · conservation held
      </div>
    </motion.div>
  );
};

export default FeeLines;
